export default function checkFeatureAvailability(feature: string, options: any) {
  const { currentUser } = options
  switch (feature) {
    case 'consumption':
      return !currentUser.hide_consumption_list
    case 'picking_list':
      return !currentUser.hide_picking_list
    case 'scan':
      return !currentUser.hide_scan
    case 'cargoflux_export':
      return !currentUser.hide_shipments
    default:
      return false
  }
}
